import { render, staticRenderFns } from "./SecurityEducationStatus.vue?vue&type=template&id=caa5f786&"
import script from "./SecurityEducationStatus.vue?vue&type=script&lang=js&"
export * from "./SecurityEducationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports